<template>
  <div id="contenedor-eliminar-contrato-anticipo">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Anticipo </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar el anticipo? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarAnticipo"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixAnticipoContrato from './mixAnticipoContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarAnticipoContrato',
  mixins: [mixAnticipoContrato],
  props: {
    contratoAnticipoEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
